import React, { useEffect } from 'react';
import EditRepReport from '../EditRepReport/EditRepReport';
import { ButtonBase } from '@mui/material';
import playIcon from '../../assets/Icons/Play.svg';
import noImageFound from '../../assets/Icons/noImageFound.svg';

const ViewRepReport = ({ refreshDataHandler, data }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = (data) => {
    console.log('data', data);
    setModalData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setModalData(null);
    refreshDataHandler();
  };
  const [modalData, setModalData] = React.useState(null);
  useEffect(() => {
    console.log('modalData', modalData);
  }, [modalData]);
  return (
    <>
      {data.map((result, index) => {
        console.log('RepReportSectionV2item', result);
        return (
          <>
            {result.edited && (
              <div className='flex justify-start'>
                <div className='bg-[#F3F3F3] rounded-t-[4px] px-5 text-[#7C7C7C] text-xs leading-4 font-semibold py-1'>
                  Edited
                </div>
              </div>
            )}
            <div
              className='bg-[#F5F9FF] mb-6 print:break-inside-avoid'
              key={`ViewRepReport${index}`}
            >
              <table className='overflow-hidden rounded-[10px] w-full font-rubik'>
                <thead>
                  <tr className='bg-[#2F2E41] text-[#FFFFFF] text-base leading-5 font-normal py-4'>
                    <th className='rounded-tl-[6px] rounded-bl-[6px] py-4 font-normal pl-8'>
                      Side view
                    </th>
                    <th className='py-4 font-normal pl-10'>Front view</th>
                    <th className=' font-normal py-4 pl-[52px]'>
                      Improvement Opportunity Level
                    </th>
                    <th className='rounded-tr-[6px] rounded-br-[6px] font-normal py-4'>
                      Remark
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <div className='mb-4 mt-3 text-[#3F3D56] text-[14px] leading-5 font-normal text-center'>
                      {result.assessment_name.toUpperCase()}
                    </div>
                  </tr>
                  <tr>
                    <td className='text-center w-1/5 pl-8'>
                      {result.side_view_assessment_report_for_reps &&
                      result.side_view_assessment_report_for_reps
                        .exercise_output_for_rep &&
                      result.side_view_assessment_report_for_reps
                        .exercise_output_for_rep.rep_stats_list[0]? (
                        <img
                          className='w-[202px] h-[147px] rounded-[10px] mx-auto my-0'
                          src={
                            result.side_view_assessment_report_for_reps
                              .exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_image_url
                          }
                          alt=''
                        />
                      ) : (
                        <div className='w-[202px] h-[147px] rounded-[10px] bg-[#ebeff5] flex justify-center items-center flex-col gap-2'>
                          <img
                            src={noImageFound}
                            alt=''
                            width={30}
                            height={30}
                          />
                          <div className='text-[#6A6A6A] text-sm opacity-70'>
                            Preview not Available
                          </div>
                        </div>
                      )}
                      <ButtonBase
                        sx={{
                          backgroundColor: '#788CFC',
                          color: '#fff',
                          width: '202px',
                          borderRadius: '5px',
                          padding: '8px 0',
                          marginTop: '12px',
                          fontSize: '12px',
                        }}
                        onClick={() => {
                          handleOpen(result);
                        }}
                      >
                        <img
                          src={playIcon}
                          className='w-[15px] h-[15px] mr-[10px]'
                          alt=''
                        />
                        View & Edit
                      </ButtonBase>
                    </td>
                    <td className='text-center w-1/5 pl-10'>
                      {result.front_view_assessment_report_for_reps &&
                      result.front_view_assessment_report_for_reps
                        .exercise_output_for_rep &&
                      result.front_view_assessment_report_for_reps
                        .exercise_output_for_rep.rep_stats_list[0] ? (
                        <img
                          className='w-[202px] h-[147px] rounded-[10px] mx-auto my-0'
                          src={
                            result.front_view_assessment_report_for_reps
                            .exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_image_url
                          }
                          alt=''
                        />
                      ) : (
                        <div className='w-[202px] h-[147px] rounded-[10px] bg-[#ebeff5] flex justify-center items-center flex-col gap-2'>
                          <img
                            src={noImageFound}
                            alt=''
                            width={30}
                            height={30}
                          />
                          <div className='text-[#6A6A6A] text-sm opacity-70'>
                            Preview not Available
                          </div>
                        </div>
                      )}
                      <ButtonBase
                        sx={{
                          backgroundColor: '#788CFC',
                          color: '#fff',
                          width: '202px',
                          borderRadius: '5px',
                          padding: '8px 0',
                          marginTop: '12px',
                          fontSize: '12px',
                        }}
                        onClick={() => {
                          handleOpen(result);
                        }}
                      >
                        <img
                          src={playIcon}
                          className='w-[15px] h-[15px] mr-[10px]'
                          alt=''
                        />
                        View & Edit
                      </ButtonBase>
                    </td>
                    <td className='text-center pb-6 w-[30%] pl-[52px]'>
                      <div
                        className='rounded-sm text-sm py-2 px-7 font-medium w-fit mx-auto my-0'
                        style={{
                          backgroundColor:
                            result.interpretation_config.background_color_code,
                          color: result.interpretation_config.font_color_code,
                        }}
                      >
                        {result.interpretation_config.interpretation}
                        {result.edited ? '*' : ''}
                      </div>
                    </td>
                    <td className='w-[30%] text-center'>
                      {result.remarks ? result.remarks : 'NA'}
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className='mx-4 pb-4 mt-[88px]'>
                <table className='overflow-hidden w-full font-rubik'>
                  <thead>
                    <tr className='bg-[#2F2E41] text-[#FFFFFF] text-base leading-5 font-normal py-4'>
                      <th className='rounded-tl-[6px] rounded-bl-[6px] py-4 font-normal text-left pl-11'>
                        Measurements
                      </th>
                      <th className='py-4 font-normal'>Measured Angle</th>
                      <th className='py-4 font-normal'>
                        Improvement Opportunity Level
                      </th>
                      <th className='rounded-tr-[6px] rounded-br-[6px] font-normal py-4 relative'>
                        <div>Legend (Degrees)</div>
                        <div className='absolute bottom-0 w-full'>
                          <div className='flex justify-center gap-[10px]'>
                            <div className='w-28 h-[5px] bg-[#119F28]'></div>
                            <div className='w-28 h-[5px] bg-[#FFB800]'></div>
                            <div className='w-28 h-[5px] bg-[#F04438]'></div>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className='bg-[#fff]'>
                    {result.front_view_assessment_report_for_reps &&
                      result.front_view_assessment_report_for_reps
                        .exercise_output_for_rep &&
                      result.front_view_assessment_report_for_reps
                        .exercise_output_for_rep.rep_stats_list[0] &&
                      result.front_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                        (item, index) => (
                          <tr className='text-[#415280] leading-4 text-sm font-normal border-b-[1px] border-b-[#b5b5b5]'>
                            <td className='text-left w-1/4 py-3 pl-12'>
                              {item.title}
                            </td>
                            <td className='text-center w-1/6 py-3'>
                              {item.value}{' '}
                            </td>
                            <td className='text-center w-1/6 py-3'>
                              {item.interpretation}
                            </td>
                            <td className='text-center py-3 flex whitespace-nowrap justify-center'>
                              <div className='w-28 text-center'>
                                {item.low_interpretation_legends &&
                                  item.low_interpretation_legends.map(
                                    (item, index) => <div>{item.legend}</div>
                                  )}
                              </div>
                              <div className='w-28 text-center'>
                                {item.moderate_interpretation_legends &&
                                  item.moderate_interpretation_legends.map(
                                    (item, index) => <div>{item.legend}</div>
                                  )}
                              </div>
                              <div className='w-28 text-center'>
                                {item.high_interpretation_legends &&
                                  item.high_interpretation_legends.map(
                                    (item, index) => <div>{item.legend}</div>
                                  )}
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                    {result.side_view_assessment_report_for_reps &&
                      result.side_view_assessment_report_for_reps
                        .exercise_output_for_rep &&
                      result.side_view_assessment_report_for_reps
                        .exercise_output_for_rep.rep_stats_list[0] &&
                      result.side_view_assessment_report_for_reps.exercise_output_for_rep.rep_stats_list[0].movement_details_list[0].movement_accuracy_parameter_details_list.map(
                        (item, index) => (
                          <tr className='text-[#415280] leading-4 text-sm font-normal border-b-[1px] border-b-[#b5b5b5]'>
                            <td className='w-1/4 py-3 text-left pl-12'>
                              {item.title}
                            </td>
                            <td className='text-center w-1/6 py-3'>
                              {item.value}{' '}
                            </td>
                            <td className='text-center w-1/6 py-3'>
                              {item.interpretation}
                            </td>
                            <td className='text-center py-3 flex whitespace-nowrap justify-center gap-[10px]'>
                              <div className='w-28 text-center flex flex-row items-center justify-center'>
                                {item.low_interpretation_legends &&
                                  item.low_interpretation_legends.map(
                                    (item, index) => (
                                      <>
                                        {Math.abs(index % 2) === 1 &&
                                          index > 0 && (
                                            <div>&nbsp; & &nbsp;</div>
                                          )}
                                        <div>{item.legend}</div>
                                      </>
                                    )
                                  )}
                              </div>
                              <div className='w-28 text-center flex flex-row items-center justify-center'>
                                {item.moderate_interpretation_legends &&
                                  item.moderate_interpretation_legends.map(
                                    (item, index) => (
                                      <>
                                        {Math.abs(index % 2) === 1 &&
                                          index > 0 && (
                                            <div> &nbsp; & &nbsp;</div>
                                          )}
                                        <div>{item.legend}</div>
                                      </>
                                    )
                                  )}
                              </div>
                              <div className='w-28 text-center flex flex-row items-center justify-center'>
                                {item.high_interpretation_legends &&
                                  item.high_interpretation_legends.map(
                                    (item, index) => (
                                      <>
                                        {Math.abs(index % 2) === 1 &&
                                          index > 0 && (
                                            <div>&nbsp; & &nbsp;</div>
                                          )}
                                        <div>{item.legend}</div>
                                      </>
                                    )
                                  )}
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        );
      })}
      {open && (
        <EditRepReport
          modalData={modalData}
          open={open}
          handleClose={handleClose}
          handleOpen={handleOpen}
        />
      )}
    </>
  );
};

export default ViewRepReport;
